var _circle, _circle2, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBmManageUsers = function SvgBmManageUsers(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(3.9 4.5)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(11.1 10.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.4,0H.6A.6.6,0,0,0,0,.6V17.4a.6.6,0,0,0,.6.6H17.4a.6.6,0,0,0,.6-.6V.6A.6.6,0,0,0,17.4,0ZM12.6,14.4a2.4,2.4,0,0,1-2.316-1.8H3.6a.6.6,0,1,1,0-1.2h6.684a2.4,2.4,0,1,1,2.316,3Zm1.8-7.8H7.716a2.4,2.4,0,1,1,0-1.2H14.4a.6.6,0,1,1,0,1.2Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmManageUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BM_ManageUsers.ba2a426e.svg";
export { ForwardRef as ReactComponent };